"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
exports.default = ({ palette }) => styles_1.createStyles({
    closeButton: {
        position: 'absolute',
        right: '2rem',
        top: '2rem',
        color: palette.grey[500],
        cursor: 'pointer',
        fontSize: '1.3rem',
        opacity: 0.3,
        '&:hover': {
            opacity: 1
        }
    }
});
//# sourceMappingURL=styles.js.map